/* components/ProductsFilters
- Used within collection and search templates

Example
<collection-filters>
    [[collection filters content]]
</collection-filters>
*/

import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { DrawerContainer } from '../Drawer/DrawerContainer';

import './CollectionFilters.scss';

@Component
export class CollectionFilters extends ThemeComponent {
    @Ref() details!: HTMLDListElement[];
    private filterToggle = document.querySelector('[data-ref="filterToggle"]') as HTMLButtonElement;
    private open: string = '';

    private drawerContainer: DrawerContainer|null = null;


    init() {
        // Set the drawer container
        this.drawerContainer = document.querySelector('.drawer[data-open-side="left"]');

        this.handleDetailsOpen(this.details);
        if (!this.filterToggle) { return; }

        this.$listen(this.filterToggle, 'click', () => {
            this.drawerContainer?.open();
        });

        const urlParams = new URLSearchParams(window.location.search);
        const paginated = urlParams.get('page');

        if (paginated) {
            const target = this.closest('.SALVO_SECTION') as HTMLElement;
            target?.scrollIntoView({ block: "start" });
        }
    }

    private handleDetailsOpen(details: HTMLDListElement[]) {

        for (const detail of details) {
            detail.addEventListener("click", () => {
                for (const sibling of details) {
                    if (detail !== sibling) {
                        sibling.removeAttribute("open");
                    }
                }
            });
        }
    }
}
